export const GEOTAG_CONFIG = {
  MAP_ICON_WIDTH_RATIO: 0.12,
  LOGO_WIDTH_RATIO: 0.3,
  MIN_LOGO_WIDTH: 250,
  LOGO_HEIGHT_RATIO: 0.25,
  LOGO_BOTTOM_MARGIN: 30,
  FONT_SIZE_BASE_RATIO: 0.022,
  MIN_FONT_SIZE: 18,
  PADDING_RATIO: 0.02,
  MIN_PADDING: 20,
  LINE_HEIGHT_MULTIPLIER: 1.8,
  SPACING: 25,
  OVERLAY_BG: '#000000',
  TEXT_COLOR: 'rgba(255, 255, 255, 0.95)',
  STATIC_ASSETS_URL:
    process.env.NEXT_PUBLIC_STATIC_URL ??
    'https://d2425810vgtj9k.cloudfront.net/static',
  MAP_ICON_PATH: '/images/ZoomedMap.svg',
  LOGO_PATH: '/images/Dataflow.png'
} as const;

export const CHAR_WIDTH_MULTIPLIER = 0.52;

export const IMAGE_MIME_TYPES = {
  PNG: 'image/png',
  WEBP: 'image/webp'
} as const;

// Image compression quality setting (0.85 provides good balance between quality and file size)
export const COMPRESSION_QUALITY = 0.85;

// Maximum file size limit for geotagged images (10MB)
export const MAX_GEOTAGGED_FILE_SIZE_MB = 10;

// Threshold for pre-compression: if original image exceeds this, compress before merging
// This prevents merged images from exceeding the 10MB limit
export const PRE_COMPRESSION_THRESHOLD_MB = 6;
